
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Bar, mixins } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
const { reactiveProp } = mixins;

@Component({
  extends: Bar,
  mixins: [reactiveProp]
})
export default class BarChart extends Vue {
  @Prop() chartData: any;
  @Prop() options: any;
  public renderChart!: (chartData: any, options: any) => void;
  public addPlugin: (plugin?: unknown) => void;

  @Watch('options')
  onOptionsChanged(): void {
    this.renderChart(this.chartData, this.options);
  }

  created(): void {
    this.addPlugin(ChartDataLabels);
  }

  mounted(): void {
    this.renderChart(this.chartData, this.options);
  }
}
